// Centralized site data - easily editable
// Real salon photos (uploaded by client)
export const SALON_PHOTOS = {
  room1: "https://customer-assets.emergentagent.com/job_harmonie-relax/artifacts/b9w82rst_8b9ea37e-5a78-448e-a10c-d4c6ade9a03c.jpg",
  table: "https://customer-assets.emergentagent.com/job_harmonie-relax/artifacts/44dxsu11_8169e517-faf6-4265-aa19-5f7a71c2a1cf.jpg",
  shelf: "https://customer-assets.emergentagent.com/job_harmonie-relax/artifacts/c6m3407s_1bb097fa-ad3f-41d0-b19f-59754d864fa6.jpg",
  perfumes: "https://customer-assets.emergentagent.com/job_harmonie-relax/artifacts/233m9jun_8ccc8268-ac03-4da8-a19b-ad09bb46c8fb.jpg",
  reception: "https://customer-assets.emergentagent.com/job_harmonie-relax/artifacts/rkja21k0_fd8f4f9c-89f3-483c-b9dd-cd935237aa81.jpg",
};

export const SITE = {
  name: "Harmony Massage",
  city: "Montélimar",
  address: "120 rue Pierre Julien, Montélimar",
  phone: "0749269508",
  phoneIntl: "+33749269508", // for tel: and wa.me
  whatsappMessage: "Bonjour, je souhaite réserver un massage.",
  mapsEmbed:
    "https://www.google.com/maps?q=120+rue+Pierre+Julien+Mont%C3%A9limar&output=embed",
};

export const HOURS = [
  { day: "Lundi", time: "09h00 – 19h00" },
  { day: "Mardi", time: "09h00 – 19h00" },
  { day: "Mercredi", time: "09h00 – 19h00" },
  { day: "Jeudi", time: "09h00 – 19h00" },
  { day: "Vendredi", time: "09h00 – 19h00" },
  { day: "Samedi", time: "09h00 – 19h00" },
  { day: "Dimanche", time: "Fermé" },
];

// Easily edit prices/durations here
export const MASSAGES = [
  {
    id: "traditionnel",
    name: "Massage Traditionnel",
    description:
      "Un rituel ancestral aux gestes précis et enveloppants qui dénoue les tensions accumulées et rétablit l'équilibre du corps.",
    image: "/generated/traditional.png",
    options: [
      { duration: "30 min", price: "60€" },
      { duration: "45 min", price: "80€" },
      { duration: "1h", price: "90€" },
    ],
  },
  {
    id: "corps-complet",
    name: "Massage Corps Complet",
    description:
      "Une immersion sensorielle de la nuque jusqu'aux pieds. Manœuvres lentes et profondes pour un relâchement total.",
    image: "/generated/corps-complet.png",
    options: [
      { duration: "30 min", price: "60€" },
      { duration: "45 min", price: "80€" },
      { duration: "1h", price: "90€" },
    ],
  },
  {
    id: "cranien",
    name: "Massage Crânien",
    description:
      "Pressions douces et drainage du cuir chevelu et de la nuque pour apaiser l'esprit et chasser le stress mental.",
    image: "/generated/cranien.png",
    options: [{ duration: "30 min", price: "30€" }],
  },
  {
    id: "dos",
    name: "Massage du Dos",
    description:
      "Soin ciblé sur la nuque, les épaules et l'ensemble du dos. Idéal pour relâcher les tensions du quotidien.",
    image: "/generated/traditional.png",
    options: [{ duration: "45 min", price: "50€" }],
  },
  {
    id: "personalise",
    name: "Massage Personnalisé",
    description:
      "Un soin entièrement adapté à vos besoins : pression, zones ciblées, huiles et techniques choisies avec vous pour une expérience sur-mesure.",
    image: "/generated/premium.png",
    options: [
      { duration: "30 min", price: "70€" },
      { duration: "45 min", price: "90€" },
      { duration: "1h", price: "100€" },
    ],
  },
];

export const GALLERY = [
  {
    src: SALON_PHOTOS.room1,
    alt: "Cabine de soin Harmony — table et étagère",
    span: "row-span-2",
  },
  {
    src: SALON_PHOTOS.perfumes,
    alt: "Sélection de parfums et huiles",
    span: "",
  },
  {
    src: SALON_PHOTOS.shelf,
    alt: "Étagère d'huiles et accessoires",
    span: "",
  },
  {
    src: SALON_PHOTOS.table,
    alt: "Table de massage prête pour le soin",
    span: "row-span-2",
  },
  {
    src: SALON_PHOTOS.reception,
    alt: "Espace d'accueil — vestiaire",
    span: "",
  },
  {
    src: "/generated/premium.png",
    alt: "Soin pierres chaudes signature",
    span: "",
  },
];

export const TESTIMONIALS = [
  {
    name: "Sophie L.",
    rating: 5,
    date: "il y a 2 semaines",
    text:
      "Un moment hors du temps. L'accueil est chaleureux, le cadre sublime et le massage absolument divin. Je reviendrai sans hésiter.",
  },
  {
    name: "Marc D.",
    rating: 5,
    date: "il y a 1 mois",
    text:
      "Le massage personnalisé est tout simplement incroyable. Je suis ressorti totalement détendu. Adresse incontournable à Montélimar.",
  },
  {
    name: "Camille R.",
    rating: 5,
    date: "il y a 3 semaines",
    text:
      "Une vraie bulle de sérénité au cœur de Montélimar. Praticien attentionné, technique irréprochable, ambiance feutrée.",
  },
  {
    name: "Julien M.",
    rating: 5,
    date: "il y a 2 mois",
    text:
      "Cadeau offert à ma femme qui en parle encore. Professionnalisme et raffinement. Merci pour ce moment d'exception.",
  },
];

export const NAV_LINKS = [
  { label: "Accueil", href: "#accueil" },
  { label: "Massages", href: "#massages" },
  { label: "Tarifs", href: "#tarifs" },
  { label: "Galerie", href: "#galerie" },
  { label: "Horaires", href: "#horaires" },
  { label: "Contact", href: "#contact" },
];
